module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h1', [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('b-form', {
    on: {
      "submit": _vm.onSubmit
    }
  }, [_c('h5', [_vm._v("Venue name:")]), _vm._v(" "), _c('b-form-input', {
    staticClass: "mb-3",
    attrs: {
      "id": "venue-name",
      "type": "text",
      "required": "",
      "placeholder": "Venue Name"
    },
    model: {
      value: (_vm.venue.name),
      callback: function($$v) {
        _vm.$set(_vm.venue, "name", $$v)
      },
      expression: "venue.name"
    }
  }), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('h5', [_vm._v("Venue price level:")]), _vm._v(" "), _c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.priceOptions
    },
    model: {
      value: (_vm.venue.price_level),
      callback: function($$v) {
        _vm.$set(_vm.venue, "price_level", $$v)
      },
      expression: "venue.price_level"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('h5', [_vm._v("Ticket Restaurant Friendly?")]), _vm._v(" "), _c('b-form-checkbox', {
    attrs: {
      "value": true,
      "unchecked-value": false
    },
    model: {
      value: (_vm.venue.is_restaurant_ticket_friendly),
      callback: function($$v) {
        _vm.$set(_vm.venue, "is_restaurant_ticket_friendly", $$v)
      },
      expression: "venue.is_restaurant_ticket_friendly"
    }
  })], 1)], 1), _vm._v(" "), _c('h5', [_vm._v("Description:")]), _vm._v(" "), _c('b-form-textarea', {
    staticClass: "mb-3",
    attrs: {
      "placeholder": "Venue description",
      "rows": 5,
      "max-rows": 6
    },
    model: {
      value: (_vm.venue.description),
      callback: function($$v) {
        _vm.$set(_vm.venue, "description", $$v)
      },
      expression: "venue.description"
    }
  }), _vm._v(" "), _c('h5', [_vm._v("Address:")]), _vm._v(" "), _c('vue-google-autocomplete', {
    ref: "address",
    staticClass: "mb-3",
    attrs: {
      "id": "map",
      "classname": "form-control",
      "placeholder": "Please type your address",
      "value": _vm.getAddressPlaceHolder(),
      "country": "fr",
      "required": ""
    },
    on: {
      "placechanged": _vm.getAddressData
    }
  }), _vm._v(" "), _c('b-tooltip', {
    attrs: {
      "show": _vm.addressError,
      "target": "map",
      "placement": "top"
    },
    on: {
      "update:show": function($event) {
        _vm.addressError = $event
      }
    }
  }, [_vm._v("\n      Please start writing an address\n    ")]), _vm._v(" "), _c('h5', [_vm._v("Pictures:")]), _vm._v(" "), _c('b-form-file', {
    staticClass: "form-control mb-3",
    attrs: {
      "type": "file",
      "multiple": "",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.upload($event.target.files)
      }
    }
  }), _vm._v(" "), _c('b-container', {
    staticClass: "p-4 bg-dark mb-3",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-row', {
    staticClass: "mb-2 text-center"
  }, _vm._l((_vm.venue.pictures), function(picture) {
    return _c('b-col', {
      key: picture.signature
    }, [_c('b-img', {
      attrs: {
        "thumbnail": "",
        "fluid": "",
        "src": _vm.getThumb(picture.url),
        "alt": "Thumbnail"
      }
    })], 1)
  })), _vm._v(" "), _c('b-row', {
    staticClass: "text-center"
  }, _vm._l((_vm.venue.pictures), function(picture, index) {
    return _c('b-col', {
      key: picture.signature
    }, [_c('b-button', {
      attrs: {
        "variant": "warning",
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.removePicture(index)
        }
      }
    }, [_vm._v("Remove")])], 1)
  }))], 1), _vm._v(" "), _c('b-button', {
    attrs: {
      "type": "submit",
      "variant": "success",
      "size": "lg"
    }
  }, [_vm._v("Ok")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0a60bd04","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Venue/Edit.vue
// module id = 656
// module chunks = 1